import { render, staticRenderFns } from "./SelectPro.vue?vue&type=template&id=58984647&scoped=true"
import script from "./SelectPro.vue?vue&type=script&lang=js"
export * from "./SelectPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58984647",
  null
  
)

export default component.exports